/**
 * ReducerComponent.ts
 * @author Diao Zheng
 * @file A Reducer component. Note that this component doesn't have legacy
 *       onBlah event handler handling.
 */
import { Disposable, } from "nasi";
import React from "react";
import * as Intent from "./Intent";
import { ReducableDispatcher } from "./ReducableDispatcher";
export class ReducerComponent extends React.Component {
    constructor(props) {
        super(props);
        this.doReduce = (dispatch) => (state, action) => {
            if (this.reducer) {
                return this.reducer(state, action, dispatch);
            }
            else if (this.actionOnlyReducer) {
                return this.actionOnlyReducer(action, dispatch);
            }
            return Intent.NoUpdate();
        };
        this.dispatcher = new ReducableDispatcher(this.doReduce, this.state, props.dispatch, this.constructor.name);
        this.disposables = new Set();
    }
    componentWillUnmount() {
        for (const disposable of this.disposables) {
            Disposable.dispose(disposable);
        }
        Disposable.dispose(this.dispatcher);
    }
    componentDidUpdate(prevProps) {
        if (prevProps.dispatch !== this.props.dispatch) {
            this.dispatcher.attachDispatcher(this.props.dispatch);
        }
        this.dispatcher.INTERNAL_reconcileAfterComponentUpdate(this.state);
    }
}
